export default __webpack_public_path__ + "static/media/TabletView.4cb23735.png";